import React from 'react';
import PortalHeader from './PortalHeader';
import RequestJob from './RequestJob';

// Dedicated Request-a-Job route (update_tasks.md §7.15, Phase 3). Reuses
// the component extracted from the Dashboard in Phase 0; the portal_visits
// audit records /request-job automatically via PortalShell.
export default function RequestJobPage() {
  return (
    <>
      <PortalHeader
        eyebrow="Need some work doing?"
        title="Request a job"
        description="Tell us what needs doing — we will come back with a date."
      />
      <RequestJob />
    </>
  );
}
